import React, { useCallback } from "react";

import { Button } from "~/ui";
import { Modal } from "~/ui/legacyFellowIndex";

interface KeyResultDeleteModalProps {
	close: (confirmDelete: boolean) => void;
	keyResultTitle?: string;
}

export function KeyResultDeleteModal({ close, keyResultTitle }: KeyResultDeleteModalProps) {
	const cancel = useCallback(() => {
		close(false);
	}, [close]);

	const confirm = useCallback(() => {
		close(true);
	}, [close]);

	const bodyText = keyResultTitle ? (
		<>
			Deleting <b>{keyResultTitle}</b> cannot be undone.
		</>
	) : (
		"This cannot be undone."
	);

	return (
		<Modal onClose={cancel}>
			<Modal.Header onClose={cancel} noBottomBorder>
				<b>Delete key result?</b>
			</Modal.Header>
			<Modal.Body>{bodyText}</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" size="normal" onClick={cancel}>
					Cancel
				</Button>
				<Button variant="destructive" size="normal" onClick={confirm}>
					Delete
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
